<div id="<%= dom_id(photo) %>" class="bg-white rounded-lg shadow-md overflow-hidden">
  <img src="data:image/jpeg;base64,<%= photo.image_data %>"
       class="w-full h-48 object-cover"
       alt="<%= photo.caption || 'Photo' %>" />
  <div class="p-4">
    <% if photo.caption %>
      <p class="text-gray-800 mb-2"><%= photo.caption %></p>
    <% end %>
    <% if photo.taken_at %>
      <time class="text-gray-500 text-sm"><%= photo.taken_at.toLocaleString() %></time>
    <% end %>
  </div>
</div>
